export default "assets/icon-section-arrow-79fb9fc7.svg";